<template>
  <div class="label-file-list">
    <!-- <ul>
      <li
        v-for="p in pictures"
        :key="p.id"
        :class="{ actived: p.id === actived }"
      >
        {{ p.createdAt | formatDate }}
      </li>
    </ul> -->
    <el-table
      height="100%"
      :data="pictures"
      :row-class-name="rowClass"
      @row-click="setDetail"
    >
      <el-table-column prop="createdAt" label="图片">
        <template slot-scope="prop">
          {{ prop.row.createdAt | formatDate('DD日 HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column label="数量" width="48">
        <template slot-scope="prop">
          {{ prop.row.distinguishCount || 0 }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    pictures: Array,
    actived: Number
  },
  methods: {
    rowClass({ rowIndex }) {
      return rowIndex === this.actived
        ? 'label-file-list-row actived'
        : 'label-file-list-row'
    },
    setDetail(row) {
      this.$emit('get-detail', row.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.label-file-list {
  // flex: 1;
  width: 180px;
  overflow: auto;
}
</style>

<style>
.label-file-list-row.actived {
  font-weight: bold;
  color: red;
}
.label-file-list-row td {
  padding: 4px 0;
}
.label-file-list-row .cell {
  user-select: none;
  cursor: pointer;
  font-size: 14px;
}
</style>
